<template>
  <!-- 打印 -->
  <div id="printbody" class="print_web" style="width: 22cm;position: relative;height:14cm;display: none;">

    <div :id="idOne">
      <div
        style="position:absolute; left: 3cm; top: 1cm;width: 10.8cm;font-weight:700;font-size:26px;margin-left:5.54cm;padding-top: 23px;font-family: '宋体';">
        北京丹大生物技术有限公司</div>
      <div
        style="position:absolute; left: 10.5cm; top: 2.5cm;width: 7.44cm;font-weight:700;font-size:20px;padding-left:20px;">
        销售出库单</div>
      <table style="position:absolute; left: 0.6cm; top: 2.7cm;font-size: 12px;font-family: '宋体';">

        <tr style="height: 0.6cm;line-height: 12px;">
          <td style="width: 1.6cm;">送货方式：</td>
          <td style="width: 7.50cm">{{ printInfo.sendType | formatSendType }}</td>

          <td style="width: 1.6cm;position:absolute; left: 18.9cm;top:0.3cm">快递单号：</td>
          <td style="width: 4.14cm;position:absolute; left: 22.3cm;top:0.3cm;text-align:left">{{ printInfo.logisMailInfo
              ? printInfo.logisMailInfo.mailno : ''
          }}</td>
        </tr>
        <tr style="height: 0.55cm">
          <td style="width: 1.6cm;">收货单位：</td>
          <td style="width: 7.50cm">
            <div style="verticle-align:middle;">{{ printInfo.logisRecipientInfo
                ? printInfo.logisRecipientInfo.customer : ''
            }}</div>
          </td>
          <td style="width: 0.10cm"></td>
          <td style="width: 1.6cm">发货日期：</td>
          <td style="width: 7.30cm">{{ printInfo.specifyDeliveryDate }}</td>
          <td style="width: 0.10cm"></td>
          <td style="width: 1.70cm">出货单编号：</td>
          <td style="width: 4.14cm">{{ printInfo.bizId }}</td>
          <!-- <td style="width: 1.62cm">订货单位</td>
          <td style="width: 5.27cm;"><div style="overflow: hidden;height: 0.6cm;verticle-align:middle;">{{ptintOutInfo.invoiceOrg}}</div></td>
          <td style="width: 0.20cm"></td>
          <td style="width: 2.27cm">发货日期</td>
          <td style="width: 3.30cm">{{ptintOutInfo.outdate | dateFormat}}</td>
          <td style="width: 0.24cm"></td>
          <td style="width: 2.52cm">出库单编号</td>
          <td style="width: 4.64cm">{{ptintOutInfo.outcode}}</td> -->
        </tr>
        <tr style="height: 0.45cm">
          <td style="width: 1.6cm;" rowspan="2">收货地址：</td>
          <td style="width: 7.50cm" rowspan="2">{{ printInfo.logisRecipientInfo
              ? printInfo.logisRecipientInfo.consigneeAddress : ''
          }}</td>
          <td style="width: 0.10cm"></td>
          <td style="width: 1.6cm">销售部门：</td>
          <td style="width: 5.30cm">{{ printInfo.applyOrgName }}</td>
          <td style="width: 0.10cm"></td>
          <td style="width: 2.30cm">订货人及电话：</td>
          <td style="width: 4.14cm">{{ printInfo.logisRecipientInfo ? printInfo.logisRecipientInfo.consigneeContact :
              ''
          }} {{ printInfo.logisRecipientInfo ? printInfo.logisRecipientInfo.consigneeTel : '' }}</td>
          <!-- <td style="width: 1.62cm;" rowspan="2">订货地址</td>
          <td style="width: 5.27cm" rowspan="2">{{ptintOutInfo.ordererAddress}}</td>
          <td style="width: 0.30cm"></td>
          <td style="width: 2.27cm"></td>
          <td style="width: 3.30cm"></td>
          <td style="width: 0.08cm"></td>
          <td style="width: 2.52cm">订货人及电话</td>
          <td style="width: 4.64cm">{{ptintOutInfo.ordererName}} &nbsp;&nbsp;&nbsp;&nbsp;{{ptintOutInfo.ordererMobile}}</td> -->
        </tr>
      </table>
    </div>
    <div :id="idTwo">
      <table class="print_table_out"
        style="position:absolute;left: 0.6cm; top: 5.7cm; width: 27.39cm;border: 1px solid black;border-bottom: 0;border-right: 0;border-left: 0;font-size: 12px;font-family: '宋体';"
        cellpadding="0" cellspacing="0">
        <thead>
          <tr style="height: 0.6cm;">
            <td style="width: 1.6cm;text-align:center;">序号</td>
            <td style="width: 2.6cm;text-align:center;">货号</td>
            <td style="width: 6.05cm;text-align:center;">品名</td>
            <td style="width: 4cm;text-align:center;">注册证号</td>
            <td style="width: 2cm;text-align:center;">规格</td>
            <td style="width: 1.6cm;text-align:center;">单位</td>
            <td style="width: 1.8cm;text-align:center;">数量</td>
            <td style="width: 1.8cm;text-align:center;">含税单价</td>
            <td style="width: 2.7cm;text-align:center;">金额</td>
            <td style="width: 2.2cm;text-align:center;">批号</td>
            <td style="width: 1cm;text-align:center;">生产日期</td>
            <td style="width: 1cm;text-align:center;">失效日期</td>
            <td style="width: 3cm;text-align:center;">储运条件</td>
            <td style="width: 3cm;text-align:center;">备注</td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in printInfo.childrens" :key="item.id" style="height: 0.6cm;">
            <td style="text-align:center;width: 1cm;min-height 0.6em;">{{ item.itemNumber ? index + 1 : '&nbsp;&nbsp;' }}
            </td>
            <td style="text-align:center;width: 1.9cm">
              {{ item.itemNumber }}
            </td>
            <td style="text-align:center;width: 1.3cm;">
              {{ item.goodsName }}
            </td>
            <td style="text-align:center;width: 1.3cm;">
              {{ item.registerProof }}
            </td>
            <td style="text-align:center;width: 1.0cm;">
              {{ item.specification }}
            </td>
            <td style="text-align:center;width: 1.0cm;">
              {{ item.storeUnitName }}
            </td>
            <td style="text-align:center;width: 1.3cm;font-weight: 600;">
              {{ item.actualOutboundNumber }}
            </td>

            <td style="text-align:center;width: 1.30cm;">
              {{ printInfo.noPrice == 'true' ? '' : item.taxIncludedUnitPrice }}
            </td>
            <td style="text-align:center;width: 2.2cm;">
              {{ printInfo.noPrice == 'true' ? '' : item.money }}
            </td>
            <td style="text-align:center;width: 1.85cm;">
              {{ item.batchNumber }}
            </td>
            <td style="text-align:center;width: 2cm;">

              <span>{{ item.produceDate }}</span>
            </td>
            <td style="text-align:center;width: 2cm;">
              <span>{{ item.exp }}</span>
            </td>
            <td style="text-align:center;width: 1.0cm;">
              {{ item.storageTemperature }}
            </td>
            <td style="text-align:center;width: 2.0cm;">
              {{ item.positions }}
            </td>
          </tr>
          <!-- </tempalte> -->
          <tr style="height: 0.6cm">
            <td style="width: 1cm;"></td>
            <td rowspan="2" style="text-align:center;width: 1.9cm;">合计：</td>
            <td colspan="5" style="text-align:right;font-size:10px;padding-right: 4px;font-weight: 600;">
              {{ printInfo.countSum }}</td>

            <td style="text-align:center;width: 1.0cm;"></td>
            <td style="text-align:center;width: 1.30cm;">
              {{ printInfo.noPrice == 'true' ? '' : printInfo.moneySum }}

            </td>
            <td style="text-align:center;width: 2.2cm;"></td>
            <td style="text-align:center;width: 1.85cm;"></td>
            <td style="text-align:center;width: 1.0cm;"></td>
            <td style="text-align:center;width: 1.0cm;"></td>
            <td style="text-align:center;width: 1.0cm;"></td>
          </tr>
          <tr style="height: 0.6cm">

            <td style="text-align:center;width: 1.9cm"></td>
            <td colspan="5" style="text-align:right;font-size:10px;padding-right: 4px;font-weight: 600;">
              {{ printInfo.zhCountSum }}</td>

            <td style="text-align:center;width: 1.0cm;"></td>
            <td style="text-align:center;width: 1.30cm;">
            </td>
            <td style="text-align:center;width: 2.2cm;"></td>
            <td style="text-align:center;width: 1.85cm;"></td>
            <td style="text-align:center;width: 1.0cm;"></td>
            <td style="text-align:center;width: 1.0cm;"></td>
            <td style="text-align:center;width: 1.0cm;"></td>
          </tr>
        </tbody>
        <tfoot>
          <tr style="height:0.79cm">
            <td colspan="2" style="text-align:center;width: 1.0cm;">备注</td>
            <td colspan="12" style="text-align:center">{{ printInfo.OutboundNote }}</td>

          </tr>
          <tr style="height:0.58cm">
            <td rowspan="5" style="width: 1cm;text-align:center;">
              客<br>
              户<br>
              须<br>
              知
            </td>
            <td colspan="6" rowspan="5" style="">
              <div style="padding: 1px 1px;">
                <span
                  style="line-height: 13px;">1.尊敬的客户，您好！以上是您所购的产品，请当面清点，若有货物缺少或者损坏的情况，请在收到货物起的三日内与我司联系。非产品质量问题，本公司将不接受投诉或者退货，谢谢！</span><br>
                <span style="line-height: 13px;">2.若发现货物有质量问题，请在收到货物时与我司技术支持部联系本公司质量投诉处理仅限于产品价值本身。</span><br>
                <span style="line-height: 13px;">3.收货确认无误后，请出库单签字并盖章交给快递员带回。</span><br>
              </div>
            </td>
            <td rowspan="5" style="width: 1.30cm;">
              <div style="width: 12px;padding-left: 17px;">生产单位</div>
            </td>
            <td colspan="2" style="border-right: 1px solid black;text-align: center;width: 2.2cm;">名称</td>
            <td colspan="4" style="padding-left: 2px;">北京丹大生物技术有限公司</td>
          </tr>
          <tr style="height:0.6cm">
            <td colspan="2" style="text-align: center;border-top: 1px solid black;width: 2.2cm;">生产许可证号</td>
            <td colspan="4" style="padding-left: 2px;solid black;">京食药监械生产许20140022号</td>
          </tr>
          <tr style="height:0.6cm">
            <td colspan="2" style="text-align: center;border-top: 1px solid black;width: 2.2cm;">纳税人识别号</td>
            <td colspan="4" style="padding-left: 2px;solid black;">911101120716743951</td>
          </tr>
          <tr style="height:0.6cm">
            <td colspan="2" style="text-align: center;width: 2.2cm;">开户银行</td>
            <td colspan="4" style="padding-left: 2px;">上海浦东发展银行北京丰台支行：91320154800008108</td>
          </tr>
          <tr style="height:0.6cm">
            <td colspan="2" style="text-align: center;width: 2.2cm;">联系电话</td>
            <td colspan="4" style="padding-left: 2px;">400-602-5201</td>
          </tr>
          <tr style="height:0.5cm">
            <td style="border: none;"></td>
            <td colspan="2" style="border: none;width: 4.9cm;">发货/仓管：</td>
            <td colspan="2" style="border: none;width: 4.05cm;">复核人：</td>
            <td colspan="4" style="border: none;width: 4.3cm;">业务员：{{ printInfo.applyName }}</td>
            <td colspan="3" style="border: none;width: 8.0cm;">电话：{{ printInfo.applyTel }}</td>
            <td colspan="2" style="border: none;width: 4.3cm;">签收人：</td>


          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</template>
<script>
import { getLodop } from '@/components/print/LodopFuncs'
import { formatDate } from '@/utils/date'
var LODOP
export default {
  filters: {
    formatSendType(sendType) {
      // 送货方式，001师傅送，002销售送，003快递运输，JHFS01_SYS发货，JHFS02_SYS自提
      if (sendType === '001') {
        return '师傅送'
      } else if (sendType === '002') {
        return '销售送'
      } else if (sendType === '003') {
        return '快递运输'
      } else if (sendType === 'JHFS01_SYS') {
        return '发货'
      } else if (sendType === 'JHFS02_SYS') {
        return '自提'
      }
    },
    priceFormat(val) {
      return val;
    },
  },
  data() {
    return {
      idOne: 'desc',
      idTwo: 'forminfo',
      printInfo: {},
      printIndex: -1,
      printNum: 1,
      orderId: '',
      ptintOutInfo: {
        stockoutDetailList: []
      },
      printnum: 1 // 打印次数
    }
  },

  methods: {

    async print2(type, orderId, index, total) {
      this.$emit('update:loading', true)
      // 先保存数据  不保存订单明细和发货位置
      // await this.save()
      // 获取数据
      this.index = index
      this.total = total
      this.orderId = orderId
      await this.initPrint(orderId, 1)
      this.print3()
      console.log(LODOP);
      if (type === 1) {
        if (LODOP.CVERSION) {
          // eslint-disable-next-line no-undef
          CLODOP.On_Return = this.printCallback
        }
        LODOP.PREVIEW()
      } else {
        // 设置默认打印机
        LODOP.SET_PRINTER_INDEX(-1)
        LODOP.PRINT()
        this.updatePrintNum(orderId, this.printNum)
      }
      this.$emit('update:loading', false)
    },


    print3(type) {
      LODOP = getLodop()
      if (!LODOP) {
        return false
      }
      LODOP.PRINT_INIT('打印出货单')
      let strBodyStyle = '<style>table,td { border: 1 solid black;border-collapse:collapse }</style>'
      let strFormHtml = strBodyStyle + '<body>' + document.getElementById(this.idTwo).innerHTML + '</body>'
      LODOP.ADD_PRINT_TABLE('5.6cm', 0, '30cm', '10cm', strFormHtml)
      LODOP.SET_PRINT_STYLEA(0, 'Vorient', 3)
      LODOP.SET_PRINT_PAGESIZE(2, '210mm', '297mm', '')
      LODOP.SET_PREVIEW_WINDOW(1, 0, 0, 900, 680, '')
      LODOP.ADD_PRINT_HTM(0, 0, '28cm', '5.6cm', document.getElementById(this.idOne).innerHTML)
      LODOP.SET_PRINT_STYLEA(0, 'HtmWaitMilSecs', 1000) // 设置上一项延迟超文本下载1000毫秒
      LODOP.SET_PRINT_STYLEA(0, 'ItemType', 1)
      LODOP.SET_PRINT_STYLEA(0, 'LinkedItem', 1)
      // 打印logo
      let qrcode = this.printInfo.logisRecipientInfo ? this.printInfo.logisRecipientInfo.qrCode : ''
      LODOP.ADD_PRINT_IMAGE('1cm', '0.8cm', '8%', '8%', 'data:image/png;base64,' + qrcode)
      LODOP.SET_PRINT_STYLEA(0, "Stretch", 2)
      LODOP.SET_PRINT_STYLEA(0, 'ItemType', 1)
      LODOP.SET_PRINT_STYLEA(0, 'LinkedItem', 1)
      // 设置条码 left: 0.35cm; top: 1.6cm;
      LODOP.ADD_PRINT_BARCODE('0.7cm', '19.5cm', '7.82cm', '0.83cm', '128A', this.printInfo.bizId)
      // LODOP.ADD_PRINT_BARCODE('1.63cm', '0.25cm', '7.82cm', '0.83cm', '128A', this.printInfo.bizId)

      LODOP.SET_PRINT_STYLEA(0, 'AlignJustify', 2)
      LODOP.SET_PRINT_STYLEA(0, 'Bold', 0)
      LODOP.SET_PRINT_STYLEA(0, 'FontSize', 3)
      LODOP.SET_PRINT_STYLEA(0, 'ItemType', 1)
      LODOP.SET_PRINT_STYLEA(0, 'LinkedItem', 1)
      LODOP.SET_SHOW_MODE("LANDSCAPE_DEFROTATED", 1)

      if (type == 3) {
        LODOP.SET_PRINTER_INDEXA(this.printNum)
        LODOP.SET_PRINT_COPIES(this.printIndex)
        LODOP.PRINT()
      }
      return true
    },
    convertCurrency(money) {
      //汉字的数字
      var cnNums = new Array('零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖');
      //基本单位
      var cnIntRadice = new Array('', '拾', '佰', '仟');
      //对应整数部分扩展单位
      var cnIntUnits = new Array('', '万', '亿', '兆');
      //对应小数部分单位
      var cnDecUnits = new Array('角', '分', '毫', '厘');
      //整数金额时后面跟的字符
      var cnInteger = '';
      //整型完以后的单位
      var cnIntLast = '';
      //最大处理的数字
      var maxNum = 999999999999999.9999;
      //金额整数部分
      var integerNum;
      //金额小数部分
      var decimalNum;
      //输出的中文金额字符串
      var chineseStr = '';
      //分离金额后用的数组，预定义
      var parts;
      if (money == '') { return ''; }
      money = parseFloat(money);
      if (money >= maxNum) {
        //超出最大处理数字
        return '';
      }
      if (money == 0) {
        chineseStr = cnNums[0] + cnIntLast + cnInteger;
        return chineseStr;
      }
      //转换为字符串
      money = money.toString();
      if (money.indexOf('.') == -1) {
        integerNum = money;
        decimalNum = '';
      } else {
        parts = money.split('.');
        integerNum = parts[0];
        decimalNum = parts[1].substr(0, 4);
      }
      //获取整型部分转换
      if (parseInt(integerNum, 10) > 0) {
        var zeroCount = 0;
        var IntLen = integerNum.length;
        for (var i = 0; i < IntLen; i++) {
          var n = integerNum.substr(i, 1);
          var p = IntLen - i - 1;
          var q = p / 4;
          var m = p % 4;
          if (n == '0') {
            zeroCount++;
          } else {
            if (zeroCount > 0) {
              chineseStr += cnNums[0];
            }
            //归零
            zeroCount = 0;
            chineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
          }
          if (m == 0 && zeroCount < 4) {
            chineseStr += cnIntUnits[q];
          }
        }
        ///chineseStr += cnIntLast + "圆";
      }
      //小数部分
      if (decimalNum != '') {
        var decLen = decimalNum.length;
        for (var i = 0; i < decLen; i++) {
          var n = decimalNum.substr(i, 1);
          if (n != '0') {
            chineseStr += cnNums[Number(n)] + cnDecUnits[i];
          } else if (n == '0') {
            chineseStr += cnNums[Number(n)];
          }
        }
      }
      if (chineseStr == '') {
        chineseStr += cnNums[0] + cnIntLast + cnInteger;
      } else if (decimalNum == '') {
        // chineseStr += cnInteger + "整";
      }
      return chineseStr;
    },
    printCallback(task, value) {
      if (value > 0) {
        this.updatePrintNum(Number(value), this.printNum)
      }

    },
    async initPrint(orderId, type) {

      this.printnum = 1
      // TODO 初始化界面需要的数据，直接往注释下面写接口获取数据，接口需要的参数有props得到。

      const result = await this.publicApi.getPrintInfo(orderId)
      if (result.code == '200') {
        this.printInfo = result.data
        this.printInfo.specifyDeliveryDate = this.printInfo.specifyDeliveryDate ? formatDate(this.printInfo.specifyDeliveryDate, 'yyyy/MM/dd') : ''
        this.printInfo.countSum = 0
        this.printInfo.moneySum = 0

        this.printInfo.childrens.forEach(item => {
          item.produceDate = item.produceDate ? formatDate(item.produceDate, 'yyyy/MM/dd') : ''
          item.exp = item.exp ? formatDate(item.exp, 'yyyy/MM/dd') : ''
          item.money = item.taxIncludedUnitPrice * item.actualOutboundNumber
          this.printInfo.countSum += item.actualOutboundNumber
          this.printInfo.moneySum += item.money
        })
        console.log(this.printInfo);
        this.printInfo.zhCountSum = this.convertCurrency(this.printInfo.countSum) + "点零零";
        while (this.printInfo.childrens.length < 7) {
          this.printInfo.childrens.push({})
        }
        if (type == 3) {
          await this.printB3()
        }

      } else {
        this.$message({
          type: 'error',
          message: result.msg
        })
        return
      }
      // 计算
      // this.computedSum()
      // if (this.ptintOutInfo.printtimes) {
      //   this.printnum = this.ptintOutInfo.printtimes
      // }
    },
    computedSum() {
      let sum = 0
      let num = 0
      this.ptintOutInfo.stockoutDetailList.forEach(el => {
        sum = this.$floatObj.add(sum, el.total)
        num = this.$floatObj.add(num, el.actnumber)
      })
      this.ptintOutInfo.sum = sum
      this.ptintOutInfo.num = num
    },
    updatePrintNum(orderId, printNum) {
      this.publicApi.update_so_print_status(orderId, printNum)
    }
  }
}
</script>

